// Light / dark theme. The choice lives in localStorage("theme"); with no
// choice saved, the device setting applies and is followed if it changes.
// public/index.html applies the attribute before first paint; this module
// keeps it in sync afterwards and lets the header switch it.

const STORAGE_KEY = "theme";
const EVENT = "avc-themechange";

function read(key) {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    return null;
  }
}

function systemTheme() {
  return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

export function getTheme() {
  const saved = read(STORAGE_KEY);
  return saved === "dark" || saved === "light" ? saved : systemTheme();
}

function apply(theme) {
  document.documentElement.setAttribute("data-theme", theme);
  window.dispatchEvent(new CustomEvent(EVENT, { detail: theme }));
}

export function setTheme(theme) {
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch (e) {
    // Private mode: the choice lasts for this page only.
  }
  apply(theme);
}

export function toggleTheme() {
  setTheme(getTheme() === "dark" ? "light" : "dark");
}

// Calls fn with the new theme whenever it changes; returns an unsubscribe.
export function onThemeChange(fn) {
  const handler = (e) => fn(e.detail);
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
}

export function initTheme() {
  apply(getTheme());
  if (!window.matchMedia) return;
  const media = window.matchMedia("(prefers-color-scheme: dark)");
  const follow = () => {
    if (!read(STORAGE_KEY)) apply(systemTheme());
  };
  if (media.addEventListener) media.addEventListener("change", follow);
  else if (media.addListener) media.addListener(follow);
}
